import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

export default function SectionEyebrow({ children, className = '' }) {
  const classes = ['section-eyebrow', className].filter(Boolean).join(' ');
  return <div className={classes}>{children}</div>;
}

SectionEyebrow.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
